import {getTestProps} from '@benchling/js-test-utils';
import classNames from 'classnames';
import React from 'react';

import * as SpreadsheetBulkImportActions from 'bulk-import/SpreadsheetBulkImportActions';
import {Registry} from 'constants/RegistryConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

interface Props {
  className?: classNames.Argument;
  registry: Registry | null;
  inOrgCollection: boolean;
  inUserCollection: boolean;
}

export default function RegistryCollectionSelection(props: Props): JSX.Element | null {
  if (!props.registry || props.registry.disablePersonalCollections) {
    return null;
  }

  const handleInOrgCollectionChange = (): void => {
    SpreadsheetBulkImportActions.setImportSetting({
      registryImportSettings: {
        inOrgCollection: !props.inOrgCollection,
      },
    });
  };

  const handleInUserCollectionChange = (): void => {
    SpreadsheetBulkImportActions.setImportSetting({
      registryImportSettings: {
        inUserCollection: !props.inUserCollection,
      },
    });
  };

  return (
    <div
      className={classNames(props.className)}
      {...getTestProps({component: 'RegistryCollectionSelection', element: 'root'})}
    >
      <label>Collection</label>
      {!props.inOrgCollection && !props.inUserCollection && (
        <span className="u-danger-color u-tiny-spacing-left">Please select at least one</span>
      )}
      <Row>
        <Col sm={6}>
          <label>
            <input type="checkbox" onChange={handleInUserCollectionChange} checked={props.inUserCollection} />
            My collection
          </label>
        </Col>
        <Col sm={6}>
          <label>
            <input type="checkbox" onChange={handleInOrgCollectionChange} checked={props.inOrgCollection} />
            Organization collection
          </label>
        </Col>
      </Row>
    </div>
  );
}
